export const NAME = "selectable"

export const Selectable = {
  ITEM: `${NAME}/SELECTABLE_TYPE/ITEM`,
  EVENT: `${NAME}/SELECTABLE_TYPE/EVENT`,
  CATEGORY: `${NAME}/SELECTABLE_TYPE/CATEGORY`,
  NONE: `${NAME}/SELECTABLE_TYPE/NONE`,
}
